import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Newsroom = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.news-card, .featured-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const newsItems = [
    {
      id: 1,
      category: "Launch",
      date: "2021",
      title: "AALITECH Founded – Hyderabad Headquarters",
      excerpt: "AALITECH, the technology flagship of AALI GROUP, was established in Hyderabad as the headquarters, marking the beginning of our journey in digital innovation and IT services.",
      fullContent: "AALITECH was founded in 2021 in Hyderabad, India, serving as the group's first venture. With a focus on digital marketing, web development, and custom software solutions, AALITECH has since grown into a trusted partner for businesses seeking digital transformation. The Hyderabad headquarters continues to drive innovation and client success.",
      image: "https://res.cloudinary.com/myhq/image/upload/w_1200/f_auto/workspaces/freshdesk-capital-park/exterior/6xmnvc.jpg",
      status: "active"
    },
    {
      id: 2,
      category: "Expansion",
      date: "2025",
      title: "AALITECH Expands – Guntur Operation Office Launched",
      excerpt: "AALITECH opens a new operation office in Guntur, Andhra Pradesh, to better serve regional clients and create local employment opportunities.",
      fullContent: "In 2025, AALITECH expanded its footprint by launching an operation office in Guntur. This strategic move allows the company to tap into local talent, support businesses in the region, and strengthen its presence in Andhra Pradesh. The Guntur office now handles client projects, technical support, and business development.",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Changed to a more suitable office image
      status: "active"
    },
    {
      id: 3,
      category: "Launch",
      date: "2026",
      title: "AALI CONSSULTANCY Goes Live – Career & Business Consulting",
      excerpt: "AALI CONSSULTANCY officially launches, offering overseas education support, employment assistance, and business consulting services.",
      fullContent: "AALI CONSSULTANCY started operations in 2026, providing a wide range of consulting services including study abroad admissions, job placement support, overseas employment assistance, and business process optimization. The consultancy has already partnered with 20+ international universities and 30+ domestic institutions, helping over 150 candidates in its first few months.",
      image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      status: "active"
    },
    {
      id: 4,
      category: "Announcement",
      date: "Late 2026",
      title: "AALI BUILDERS – Planned Launch by End of 2026",
      excerpt: "AALI GROUP announces the upcoming launch of AALI BUILDERS, focusing on sustainable construction and infrastructure development.",
      fullContent: "Scheduled for launch by the end of 2026, AALI BUILDERS will bring innovative construction solutions, sustainable building practices, and modern infrastructure projects to various markets. The initial project pipeline includes residential complexes and commercial developments. Further details will be unveiled closer to launch.",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      status: "upcoming"
    },
    {
      id: 5,
      category: "Future Ventures",
      date: "Future",
      title: "AALI TRUSTZ, AALI MUSIC, AALI MOVIES, AALI FILMZ, AALI GOLD JEWELZ – Coming Soon",
      excerpt: "AALI GROUP expands its vision with five new verticals: social impact, music, film production, digital content, and luxury jewellery — all planned for future launch.",
      fullContent: "As part of its long‑term growth strategy, AALI GROUP is planning to launch AALI TRUSTZ (social impact foundation), AALI MUSIC (music label), AALI MOVIES (film production), AALI FILMZ (digital content studio), and AALI GOLD JEWELZ (luxury jewellery). These ventures will further diversify the group's portfolio and create new opportunities for talent, artists, and communities.",
      image: "/assets/opt/news-gold.webp",
      status: "upcoming"
    },
    {
      id: 6,
      category: "Announcement",
      date: "Future",
      title: "AALI GROUP – Future Listing Plans",
      excerpt: "AALI GROUP is exploring a potential public listing in the future to fuel growth, enhance transparency, and create stakeholder value.",
      fullContent: "While AALI GROUP currently operates as a privately held conglomerate, the leadership is actively evaluating opportunities for a public listing in the coming years. This strategic move would enable the group to access capital markets, accelerate expansion, and offer investors a chance to participate in its success story. More details will be shared as plans develop.",
      image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      status: "upcoming"
    }
  ];

  const featured = newsItems[0]; // Change index to show a different featured card if needed

  return (
    <>
      <div className="newsroom-hero">
        <div className="container">
          <h1>Newsroom</h1>
          <p>Latest updates from AALI GROUP – celebrating active ventures and announcing future horizons</p>
        </div>
      </div>

      <div className="newsroom-container">
        <div className="container">
          {/* Featured Story */}
          <div className="featured-section">
            <div className="featured-card scroll-reveal">
              <div className="featured-image">
                <img src={featured.image} alt={featured.title} />
                <div className="featured-category">{featured.category}</div>
              </div>
              <div className="featured-content">
                <div className="news-meta">
                  <span className="news-date"><i className="far fa-calendar-alt"></i> {featured.date}</span>
                  <span className="news-badge active">Operational</span>
                </div>
                <h2>{featured.title}</h2>
                <p>{featured.excerpt}</p>
                <button className="read-more" onClick={() => toggleExpand(featured.id)}>
                  {expandedId === featured.id ? 'Read less ↑' : 'Read more ↓'}
                </button>
                {expandedId === featured.id && (
                  <div className="expanded-content">
                    <p>{featured.fullContent}</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* All News Grid */}
          <div className="latest-section">
            <div className="section-header">
              <h2>All Updates</h2>
              <div className="header-line"></div>
            </div>
            <div className="news-grid">
              {newsItems.map((item) => (
                <div key={item.id} className="news-card scroll-reveal">
                  <div className="news-image">
                    <img src={item.image} alt={item.title} />
                    <div className="news-category-tag">{item.category}</div>
                    {item.status === 'active' && <div className="status-badge active">LIVE</div>}
                    {item.status === 'upcoming' && <div className="status-badge upcoming">COMING SOON</div>}
                  </div>
                  <div className="news-content">
                    <div className="news-meta">
                      <span className="news-date"><i className="far fa-calendar-alt"></i> {item.date}</span>
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.excerpt}</p>
                    <button className="read-more-link" onClick={() => toggleExpand(item.id)}>
                      {expandedId === item.id ? 'Show less' : 'Read more →'}
                    </button>
                    {expandedId === item.id && (
                      <div className="expanded-content">
                        <p>{item.fullContent}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Simple Media Contact */}
          <div className="media-contact">
            <div className="contact-inner">
              <i className="fas fa-envelope-open-text"></i>
              <h3>Media & Press Inquiries</h3>
              <p>For interview requests or more information about our ventures, please reach out to our communications team.</p>
              <div className="contact-buttons">
                <Link to="/contact" className="btn-primary">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsroom;